// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as StimulusTabContext$LiteracyplanetTupperware from "./StimulusTabContext.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "../v3/TupperwareLayoutSwitch.res.mjs";
import * as PilotStimulusTabContent$LiteracyplanetTupperware from "./PilotStimulusTabContent.res.mjs";
import * as ClickWordToHearContainer$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ClickWordToHearContainer.res.mjs";

function SkilfulStimulusTabContent$Skilful(props) {
  var showing = Curry._1(StimulusTabContext$LiteracyplanetTupperware.useTabContent, props.tab);
  return React.createElement(ClickWordToHearContainer$LiteracyplanetClientFlags.make, {
              children: showing ? props.children : null
            });
}

var Skilful = {
  make: SkilfulStimulusTabContent$Skilful
};

function SkilfulStimulusTabContent(props) {
  var children = props.children;
  var tab = props.tab;
  if (Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot") {
    return React.createElement(PilotStimulusTabContent$LiteracyplanetTupperware.make, {
                tab: tab,
                children: children
              });
  } else {
    return React.createElement(SkilfulStimulusTabContent$Skilful, {
                tab: tab,
                children: children
              });
  }
}

var make = SkilfulStimulusTabContent;

var $$default = SkilfulStimulusTabContent;

export {
  Skilful ,
  make ,
  $$default as default,
}
/* react Not a pure module */
